import { createLogger, stdSerializers } from 'browser-bunyan';
import { useCallback } from 'react';

import { CustomConsoleFormattedStream } from '@/lib/logger/console-stream';
import { ServerStream } from '@/lib/logger/server-stream';

export const logger = new (class {
    log = createLogger({
        name: 'logger',
        streams: [
            {
                level: 'info',
                stream: new CustomConsoleFormattedStream(),
            },
            {
                level: 'info',
                stream: new ServerStream(),
            },
        ],
        serializers: stdSerializers,
    });
})();

export interface Logger {
    debug: (message: string, extra?: object) => void;
    info: (message: string, extra?: object) => void;
    warn: (message: string, extra?: object) => void;
    error: (message: string, extra?: object, error?: unknown) => void;
    fatal: (message: string, extra?: object) => void;
    userAction: (userAction: string, message: string, extra?: object) => void;
}

export const useLogger = (args: { component?: string; hook?: string }): Logger => {
    const debug = useCallback(
        (message: string, extra: object = {}) => {
            logger.log.debug({ ...args, ...extra }, message);
        },
        [args]
    );
    const info = useCallback(
        (message: string, extra: object = {}) => {
            logger.log.info({ ...args, ...extra }, message);
        },
        [args]
    );
    const warn = useCallback(
        (message: string, extra: object = {}) => {
            logger.log.info({ ...args, ...extra }, message);
        },
        [args]
    );
    const error = useCallback(
        (message: string, extra: object = {}, error?: unknown) => {
            logger.log.error({ ...args, ...extra }, message, error);
        },
        [args]
    );
    const fatal = useCallback(
        (message: string, extra: object = {}) => {
            logger.log.fatal({ ...args, ...extra }, message);
        },
        [args]
    );
    const userAction = useCallback(
        (userAction: string, message: string, extra: object = {}) => {
            logger.log.info({ ...args, ...extra, userAction }, message);
        },
        [args]
    );

    return {
        debug,
        info,
        warn,
        error,
        fatal,
        userAction,
    };
};
